import * as React from 'react';
import { connect } from 'react-redux';
import { debug } from '../../../utils';
import { search, getResults, paramsFromProps, generateQueryParams } from '../../models/Search';
import { reduxForm, Field } from 'redux-form';
import { withRouter } from 'react-router';
import SearchResult from './SearchResult';
import { LinkHelper } from '../../routes';
import isEmpty from 'lodash/isEmpty';
import map from 'lodash/map';
import mapKeys from 'lodash/mapKeys';
import omit from 'lodash/omit';
import isString from 'lodash/isString';
import every from 'lodash/every';
import { setResultSelected, setResultHovered, setMapLocation, adjustWindowShade, setMapControlled } from '../../models/Map/actions';
import NoGPS from './NoGPS';
import WindowShade from './WindowShade'
const styles = require('./Search.less') as any;
const renameKeys = (collection, rename_map) => mapKeys(collection, (value, key) => rename_map[key] || key);

const log = debug('lego:Search.tsx');
import SearchBox from './SearchBox';
// must be at least x,y === >= 3
/* const getPositionFromParams = (position) => {
 *		 if (isString(position && position.length >= 3)
 *				 return 1;
 *				 //throw 'Invalid position string in query params';
 * }*/

import throttle from 'lodash/throttle'

interface SearchProps {
	results: any;
	query: any;
	location: any;
	router: any;
	handleSubmit: any;
	search(any): any;
	mapState: any;
	setResultHovered: any;
	setResultSelected: any;
	userPosition: any;
  mapComponent: any;
  setMapLocation;
  browser: any;
  center: any;
	routes: any;
	adjustWindowShade: any;
	setMapControlled: any;
}
interface SearchState {}
import { autobind } from 'core-decorators'
import { Coord, Bounds } from '../../models/Location/mapUtils';
import { getCenter, DEFAULT_POSITION, getUserPosition, fitPoints, allPointsInBounds, pointsInBounds } from '../../models/Location';

let initialized = false;
const debouncedSetResultHovered = throttle(setResultHovered, 500)
const mapStateToProps = (state, ownProps) => ({
	initialValues: {q: ownProps.location.query['q']},
	results: getResults(
		state,
		paramsFromProps({
			// TODO: keyword || latest || nearby
			location: ownProps.location,
			mapState: state.mapState,
			center: new Coord(state.mapState.map_location)
		})),
	mapState: state.mapState,
  mapComponent: state.mapComponent,
	userPosition: state.userPosition,
  browser: state.browser,
  center: getCenter(state.mapState, state.userPosition)
});
@connect(mapStateToProps, { search, setResultSelected, setResultHovered: debouncedSetResultHovered, setMapLocation, adjustWindowShade, setMapControlled })
@reduxForm({form: 'searchForm'})
class Search extends React.Component< SearchProps,SearchState> {
  waitingForUserPosition: any = false;

	componentWillMount() {
    const { userPosition, mapState, center, location } = this.props;
		if (!initialized) {
			if (!mapState.map_controlled && (!userPosition || !userPosition.data || userPosition.inProgress)) {
				this.waitingForUserPosition = setTimeout(() => this.initialSearch(), 5000);
			} else {
				this.search(paramsFromProps({mapState, center, location}));
			}
		}
	}

  initialSearch() {
    const { mapState, center, location } = this.props;
    clearTimeout(this.waitingForUserPosition);
    this.waitingForUserPosition = false;
    this.search(paramsFromProps({mapState, center, location}));
		initialized = true;
  }

  componentWillReceiveProps(nextProps) {
    const { userPosition, mapState } = this.props;
    if (this.waitingForUserPosition
        && (mapState.map_controlled || (userPosition && userPosition.data && !userPosition.inProgress))) {
      this.initialSearch();
    }
  }

	onSubmit(values) {
		const params = renameKeys(values, {q: 'keyword'});
		this.search(params);
	}

  updateUrl(query) {
    const { router } = this.props;
		if (!router.isActive('/search/')) return;
		const params = generateQueryParams(query)
    router.push(router.createPath({
			pathname: '/search/',
			query: params
		}));
  }

	search(params) {
		const { router, mapComponent, mapState, center, location, userPosition } = this.props
		const userPos = getUserPosition(userPosition)
		// TODO: if last query exists && matches current keyword then return results of last query
		// const query = {...paramsFromProps(this.props), ...params, ...(mapState.map_location)};
		const map = this.props.mapComponent && this.props.mapComponent();
		const userInBounds = !allPointsInBounds([userPos], map)
		const searchCenter = userInBounds ? {...center, ...userPos} : center
    const query = {...paramsFromProps(this.props), ...params, ...(searchCenter)};
		query['sort'] = query.keyword.length > 0 ? 'relevance' : 'distance';
		const isNearbySearch = (!query.keyword || query.length <= 0);
    const { keyword, sort, latitude, longitude } = query;
		const promise = this.props.search({...query})
												.then((results) => {
													const map = this.props.mapComponent && this.props.mapComponent();
													const points = results.places.map(place => place.location.position);
                          const resultsInBounds = pointsInBounds(points, map).length > 0
													if (!resultsInBounds) {
														fitPoints(points, this.props.setMapLocation)
														if (!isNearbySearch) this.props.setMapControlled(true)
													}
												});
    this.updateUrl(query);
    return promise;
	}

	@autobind
  setResultSelected(result) {
    this.props.setResultSelected(result.id);
  }

	render_results(results) {
		const { mapState, userPosition } = this.props;
		//if (!results) this should not happen?
    if (this.waitingForUserPosition) return render_waiting_for_gps();
		if (results.inProgress) return render_loading_results();
		if (!results.data || results.data.length === 0) return render_empty_results();

		return (
      <div className={styles.StupidSafariContainer}>
        <WindowShade className={styles.SearchResultsContainer} adjustWindowShade={this.props.adjustWindowShade} position={mapState.windowShade}>
				  <ol className={styles.SearchResults}>
					  {results.data.map((place, index) => (
						   <SearchResult key={`${index}-result`}
                             position={getUserPosition(userPosition)}
                             setResultHovered={this.props.setResultHovered}
                             setResultSelected={(id)=>this.setResultSelected(place)}
																	 {...place}
                             {...mapState}
               />))}
				  </ol>
        </WindowShade>
      </div>
		);
	}

	render() {
		const { results, location, handleSubmit, userPosition, browser } = this.props;
		const { q: query } = location.query;
		const isNearbySearch = (!query || query.length <= 0);
    const isMobile = browser.lessThan.small;
		return (
			<div className={styles.SearchPanel}>
				<div className={styles.Header}>
					<div className={styles.SearchContainer}>
						<form onSubmit={handleSubmit(this.onSubmit.bind(this))}>
							<Field name='q' type='search' autoCapitalize='off' component={SearchBox} label='Search' />
						</form>
					</div>
					<header className={styles.ResultsHeader}>
						{userPosition.error && <NoGPS code={userPosition.error.code}/>}
						{isNearbySearch ?
						 <span>Places Near You</span> :
						 <span>Results for <span style={{color: 'mediumblue'}}>{query}</span>...</span>}
					</header>
				</div>
				{this.render_results(results)}
			</div>
		);
	}
}

import classNames from 'classnames';
import Icon from 'react-fa';
export default withRouter(Search);

function render_loading_results() {
	return (
		<div className={styles.LoadingResults}>
			<p><Icon spin name="spinner" /> Searching...</p>
		</div>
	);
}

function render_waiting_for_gps() {
	return (
		<div className={styles.LoadingResults}>
			<p><Icon spin name="spinner" /> Searching...</p>
		</div>
	);
}

function render_empty_results() {
	return (
		<div className={styles.LoadingResults}>
			<p>Your query returned no results. Check spelling and try entering your search again.</p>
		</div>
	);
}



// WEBPACK FOOTER //
// ./src/app/containers/Search/Search.tsx